<script>
import CreditTransactions from '@/V2/credit/components/CreditTransactions';

export default {
  components: { CreditTransactions },
};
</script>

<template>
  <div class="credit-transactions-page d-flex justify-content-center i-p-11">
    <credit-transactions></credit-transactions>
  </div>
</template>

<style lang="scss" scoped>
.credit-transactions-page {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  .credit-transactions {
    width: 1200px;
  }
}
</style>
